import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CustomerService } from '../auth/services/customer.service';
import { IUserMgmtUser } from './IUserMgmtUser';

@Injectable()
export class UserMgmtService {
  constructor(private http: HttpClient, private customerService: CustomerService) { }

  list(): Observable<{institutionId: number, institutionName: string, parentInstitutionName: string, users: IUserMgmtUser[]}> {
    const institutionId = this.customerService.institution.id;
    return this.http.get<{institutionId: number, institutionName: string, parentInstitutionName: string, users: IUserMgmtUser[]}>
      (`${environment.baseUrl}/institutions/${institutionId}/users`);
  }

  validateUser(email: string): Observable<IUserMgmtUser> {
    const params = this.createRequestOptions({institutionId: this.customerService.institution.id.toString(), email});
    return this.http.get<IUserMgmtUser>(`${environment.baseUrl}/users/validate`, params);
  }

  addUser(user: IUserMgmtUser): Observable<IUserMgmtUser> {
    return this.http.post<IUserMgmtUser>(`${environment.baseUrl}/users`, user);
  }

  enableUser(userId: number): Observable<IUserMgmtUser> {
    const institutionId = this.customerService.institution.id;
    return this.http.put<IUserMgmtUser>(`${environment.baseUrl}/institutions/${institutionId}/users/${userId}/status/?enabled=true`, {});
  }

  disableUser(user: IUserMgmtUser): Observable<IUserMgmtUser> {
    const institutionId = this.customerService.institution.id;
    return this.http.put<IUserMgmtUser>(`${environment.baseUrl}/institutions/${institutionId}/users/${user.id}/status/?enabled=false`, {});
  }

  sendInvite(user: IUserMgmtUser): Observable<IUserMgmtUser> {
    const userPayload = {
      email: user.email,
      institutionName: user.institution,
      userStatus: user.status
    };
    return this.http.post<IUserMgmtUser>(`${environment.baseUrl}/users/sendinvite`, userPayload);
  }

  removeUser(user: any): Observable<IUserMgmtUser> {
    const institutionId = this.customerService.institution.id;
    return this.http.delete<IUserMgmtUser>(`${environment.baseUrl}/institutions/${institutionId}/users/${user.id}`);
  }

  editUser(user: IUserMgmtUser): Observable<IUserMgmtUser> {
    const institutionId = this.customerService.institution.id;
    const userPayload = { email: user.email,
      firstName: user.firstName,
      institutionId: this.customerService.institution.id,
      institutionName: this.customerService.institution.name,
      lastName: user.lastName,
      newUser: false,
      role: user.role,
      sendEmailInvite: false
    };
    return this.http.put<IUserMgmtUser>(`${environment.baseUrl}/institutions/${institutionId}/users/${user.id}`, userPayload);
  }

  private createRequestOptions(paramsObj?: { [key: string]: string; }) {
    const params: HttpParams = paramsObj
      ? Object.keys(paramsObj).reduce(
        (previous, key) => previous.set(key, paramsObj[key]),
        new HttpParams({ encoder: new HttpUrlEncodingCodec()}))
      : undefined;
    return { params };
  }
}
